/* Data palette for charts, timelines and Stripe Elements: canvas, SVG attributes
   and Stripe's iframe can't read CSS variables. UI colour comes from kit tokens. */
export const theme = {
  colors: {
    danger: '#FF4218',
    green: '#3EC247',
    grey: '#ACADB6',
    lightGrey: '#525268',
    orange: '#FFA51E',
    success: '#4AAD84',
    yellow: '#FFC700',
  },
  sizes: {
    headerHeight: 56,
  },
};
